import ConfirmationModal from "../../components/ConfirmationModal";

const DeleteDraftModal = ({ show, onClose, onConfirm, isLoading }) => (
    <ConfirmationModal
        show={show}
        title="Are you sure you want to delete this draft?"
        description="This action cannot be undone."
        variant="danger"
        confirmLabel="Delete Draft"
        busyLabel="Deleting…"
        isBusy={isLoading}
        onCancel={onClose}
        onConfirm={onConfirm}
    />
);

export default DeleteDraftModal;
